<template>
  <div class="sta_box">
    <div class="item">{{showData.all_square_count + "m³"}}<span class="title">历史销售方数</span></div>
    <div class="item">{{showData.all_sell_count}}<span class="title">历史成交客户数</span></div>
    <div class="item">{{'¥'+showData.sell_money_count}}<span class="title">历史销售金额</span></div>
    <div class="item">{{showData.m_square_count + "m³"}}<span class="title">当月销售方数</span></div>
    <div class="item">{{showData.m_sell_count}}<span class="title">当月成交客户数</span></div>
    <div class="item">{{showData.m_customer_count}}<span class="title">当月新增客户</span></div>
    <div class="item"  v-if="module.indexOf(',customer-index-maoli,')!=-1">{{'¥' + profitData}}<span class="title">历史销售毛利</span></div>
  </div>
</template>

<script>    
export default {
    props: {
        showData:{
            type: Object,
            default: function(){
                return {
                    all_square_count: 0,
                    all_sell_count: 0,
                    sell_money_count:0,
                    is_admin:0,
                    m_square_count: 0,
                    m_sell_count: 0,
                    m_customer_count: 0
                }
            }
        },
        profitData: {
            type: String,
            default: function(){
                return '0'
            }
        }
    },
    data(){
        return {
            module:localStorage.dw_erp_power_code
        }
    }
}
</script>

<style lang="scss" scoped>
.sta_box{
    display: flex;
    width: 100%;
    margin-top: 20px;
    .item{
        flex: 1;
        position: relative;
        height: 92px;    
        line-height: 92px;
        align-items: center;
        margin-left: 20px;
        border: 1px solid #eee;
        box-shadow: 0 0 5px #ddd;
        font-weight: 700;
        padding-top: 10px;
        .title{
            position: absolute;
            top: -20px;
            left: 0;
            right: 0;
            font-size: 15px;
            font-weight: 600;
            color: #666;
        }      
    }
    .item:first-child{
        margin-left: 0px;
    }
}
</style>